export const RESET_QUESTIONNAIRE = 'RESET_QUESTIONNAIRE';
export const INITIATE_QUESTIONNAIRE = 'INITIATE_QUESTIONNAIRE';
export const INITIATE_QUESTIONNAIRE_SUCCESS =
    'INITIATE_QUESTIONNAIRE_SUCCESS';
export const INITIATE_QUESTIONNAIRE_FAILURE =
    'INITIATE_QUESTIONNAIRE_FAILURE';
export const SEND_QUESTION = 'SEND_QUESTION';
export const SEND_QUESTION_SUCCESS = 'SEND_QUESTION_SUCCESS';
export const SEND_QUESTION_FAILURE = 'SEND_QUESTION_FAILURE';
export const GET_RECOMMENDED_RESULTS = 'GET_RECOMMENDED_RESULTS';
export const GET_RECOMMENDED_RESULTS_SUCCESS =
    'GET_RECOMMENDED_RESULTS_SUCCESS';
export const GET_RECOMMENDED_RESULTS_FAILURE =
    'GET_RECOMMENDED_RESULTS_FAILURE';
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const GET_ALL_PRODUCTS_SUCCESS = 'GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_FAILURE = 'GET_ALL_PRODUCTS_FAILURE';
export const REMOVE_LAST_QUESTION = 'REMOVE_LAST_QUESTION';
export const REMOVE_LAST_QUESTION_SUCCESS =
    'REMOVE_LAST_QUESTION_SUCCESS';
export const UPDATE_CURRENT_QUESTIONNAIRE =
    'UPDATE_CURRENT_QUESTIONNAIRE';
export const UPDATE_CURRENT_QUESTIONNAIRE_SUCCESS =
    'UPDATE_CURRENT_QUESTIONNAIRE_SUCCESS';
export const GET_AEM_CONTENT = 'GET_AEM_CONTENT';
export const GET_AEM_CONTENT_SUCCESS = 'GET_AEM_CONTENT_SUCCESS';
export const GET_AEM_CONTENT_FAILURE = 'GET_AEM_CONTENT_FAILURE';
export const RESET_QUESTIONNAIRE_BUSINESSTYPE =
    'RESET_QUESTIONNAIRE_BUSINESSTYPE';
export const UPDATE_FORM_FIELDS_BUSINESSTYPE =
    'UPDATE_FORM_FIELDS_BUSINESSTYPE';
export const UPDATE_FORM_FIELDS_BUSINESDURATION =
    'UPDATE_FORM_FIELDS_BUSINESDURATION';
export const INITIATE_GOAL_QUESTIONNAIRE_SUCCESS =
    'INITIATE_GOAL_QUESTIONNAIRE_SUCCESS';
export const INITIATE_GOAL_QUESTIONNAIRE_FAILURE =
    'INITIATE_GOAL_QUESTIONNAIRE_FAILURE';
export const INITIATE_GOAL_QUESTIONNAIRE =
    'INITIATE_GOAL_QUESTIONNAIRE';
export const REMOVE_LAST_BUSINESS_QUESTION =
    'REMOVE_LAST_BUSINESS_QUESTION';
export const UPDATE_CURRENT_BUSINESS_QUESTIONNAIRE =
    'UPDATE_CURRENT_BUSINESS_QUESTIONNAIRE';
export const REMOVE_LAST_BUSINESS_QUESTION_SUCCESS =
    'REMOVE_LAST_BUSINESS_QUESTION_SUCCESS';
export const UPDATE_CURRENT_BUSINESS_QUESTIONNAIRE_SUCCESS =
    'UPDATE_CURRENT_BUSINESS_QUESTIONNAIRE_SUCCESS';
export const RESET_BUSINESS_QUESTIONNAIRE =
    'RESET_BUSINESS_QUESTIONNAIRE';

export const FORM_VALUE_CHANGE = 'FORM_VALUE_CHANGE';

export const VISIBLE_QUESTIONS_RESET = 'VISIBLE_QUESTIONS_RESET';
export const VISIBLE_QUESTIONS_UPDATED = 'VISIBLE_QUESTIONS_UPDATED';
export const GET_BANKER_RECOMMENDED_RESULTS =
    'GET_BANKER_RECOMMENDED_RESULTS';
export const GET_BANKER_RECOMMENDED_RESULTS_SUCCESS =
    'GET_BANKER_RECOMMENDED_RESULTS_SUCCESS';
export const GET_BANKER_RECOMMENDED_RESULTS_FAILURE =
    'GET_BANKER_RECOMMENDED_RESULTS_FAILURE';
export const RESET_SELECTION = 'RESET_SELECTION';
export const SEND_EMAIL_WITH_RECOMMENDATIONS =
    'SEND_EMAIL_WITH_RECOMMENDATIONS';
export const SEND_EMAIL_WITH_RECOMMENDATIONS_SUCCESS =
    'SEND_EMAIL_WITH_RECOMMENDATIONS_SUCCESS';
export const SEND_EMAIL_WITH_RECOMMENDATIONS_FAILURE =
    'SEND_EMAIL_WITH_RECOMMENDATIONS_FAILURE';
export const SET_PRODUCT_FILTER_LIST = 'SET_PRODUCT_FILTER_LIST';
export const SET_BANKER_RECOMMENDEDN_RESULTS_FILTER =
    'SET_BANKER_RECOMMENDEDN_RESULTS_FILTER';
export const SET_NON_SENSITIVE_USER_DETAILS =
    'SET_NON_SENSITIVE_USER_DETAILS';
export const GET_ALL_BANKER_PRODUCTS = 'GET_ALL_BANKER_PRODUCTS';
export const GET_ALL_BANKER_PRODUCTS_SUCCESS =
    'GET_ALL_BANKER_PRODUCTS_SUCCESS';
export const GET_ALL_BANKER_PRODUCTS_FAILURE =
    'GET_ALL_BANKER_PRODUCTS_FAILURE';
export const RESET_REVIEW_QUESTIONS = 'RESET_REVIEW_QUESTIONS';
export const UPDATE_UNSAVED_ANSWERS_ON_SAVE =
    'UPDATE_UNSAVED_ANSWERS_ON_SAVE';
export const CLEAR_UNSAVED_ANSWERS_ON_DISCARD =
    'CLEAR_UNSAVED_ANSWERS_ON_DISCARD';
